<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style lang="stylus">
@import './styles/global';

#app {
  background: white;
  min-height: 100vh;
  position: relative;
}
</style>
